import { c as _c } from "react/compiler-runtime";
import { TerraLink } from "../../component/TerraLink/TerraLink";
import { IconTextDumpling } from "../../component/IconTextDumpling/IconTextDumpling";
import { renderHeaderConditionally } from "../../utils/functions";
import { CommonDescription } from "../../component/CommonDescription/CommonDescription";
import { layoutHeaderClasses, layoutHeaderBigClasses, layoutSubheaderClasses, layoutEyebrowClasses } from "@/components/tailwindHelpers";
import { darkTextureWrapper, colorSettingDetection } from "../../utils/functions";
export interface LayoutBlocks {
  eyebrow?: string;
  header?: string;
  headerElement?: "h1" | "h2";
  subheader?: string;
  description?: string;
  iconTextItems?: IconTextDumpling[];
  buttons?: TerraLink[];
  presetTheme?: "t2-theme-one" | "t2-theme-two" | "t2-theme-three" | "t2-theme-four" | "t2-theme-five" | "t2-theme-six" | "t2-theme-seven";
  isHeaderBig?: boolean;
  isWrapped?: boolean;
  isCenteredItems?: boolean;
  isIconVisible?: boolean;
}
export const LayoutBlocks = t0 => {
  const $ = _c(49);
  const {
    eyebrow,
    header,
    headerElement: t1,
    subheader,
    description,
    iconTextItems,
    buttons,
    presetTheme,
    isHeaderBig,
    isWrapped,
    isCenteredItems,
    isIconVisible
  } = t0;
  const headerElement = t1 === undefined ? "h2" : t1;
  const hasPrimaryContent = !!(eyebrow || header || subheader || description || buttons);
  const wrapperClasses = `${isWrapped ? "w-full px-5 lg:px-20 m-auto max-w-[1440px]" : ""}`;
  const centeredItems = `${isCenteredItems ? "text-center" : ""}`;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== buttons || $[1] !== centeredItems || $[2] !== description || $[3] !== eyebrow || $[4] !== hasPrimaryContent || $[5] !== header || $[6] !== headerElement || $[7] !== iconTextItems || $[8] !== isHeaderBig || $[9] !== isIconVisible || $[10] !== presetTheme || $[11] !== subheader || $[12] !== wrapperClasses) {
    const colorSetting = colorSettingDetection(presetTheme || "");
    const mainClasses = `pt-[100px] pb-[55px] ${presetTheme || ""} ${colorSetting}`;
    const itemsClasses = `flex flex-wrap justify-between ${centeredItems}`;
    const headerClasses = `${isHeaderBig ? layoutHeaderBigClasses : layoutHeaderClasses}
`;
    const t10 = header || "";
    let t11;
    if ($[21] !== headerClasses || $[22] !== headerElement || $[23] !== t10) {
      t11 = renderHeaderConditionally(headerClasses, t10, headerElement);
      $[21] = headerClasses;
      $[22] = headerElement;
      $[23] = t10;
      $[24] = t11;
    } else {
      t11 = $[24];
    }
    const finalHeader = t11;
    const t12 = presetTheme || "";
    let t13;
    if ($[25] !== t12) {
      t13 = darkTextureWrapper(t12);
      $[25] = t12;
      $[26] = t13;
    } else {
      t13 = $[26];
    }
    const componentStyles = t13;
    t7 = mainClasses;
    t8 = componentStyles;
    t9 = "layout-blocks";
    t6 = wrapperClasses;
    t4 = "t2-layout__content";
    if ($[27] !== buttons || $[28] !== description || $[29] !== eyebrow || $[30] !== finalHeader || $[31] !== hasPrimaryContent || $[32] !== subheader) {
      t5 = hasPrimaryContent && <div className=""><div className={layoutEyebrowClasses}>{eyebrow}</div>{finalHeader}{subheader && <div className={layoutSubheaderClasses}>{subheader}</div>}{description && <CommonDescription description={description} className="t2-layout__description" />}<div className="mt-10 t2-layout__cta">{buttons && buttons.map(_temp)}</div></div>;
      $[27] = buttons;
      $[28] = description;
      $[29] = eyebrow;
      $[30] = finalHeader;
      $[31] = hasPrimaryContent;
      $[32] = subheader;
      $[33] = t5;
    } else {
      t5 = $[33];
    }
    t2 = itemsClasses;
    t3 = iconTextItems && iconTextItems.map((item, index_0) => <div key={`icon-text-${index_0}`} data-testid="block-item"><IconTextDumpling {...item} isIconVisible={isIconVisible} isDarkTheme={colorSetting?.includes("dark")} /></div>);
    $[0] = buttons;
    $[1] = centeredItems;
    $[2] = description;
    $[3] = eyebrow;
    $[4] = hasPrimaryContent;
    $[5] = header;
    $[6] = headerElement;
    $[7] = iconTextItems;
    $[8] = isHeaderBig;
    $[9] = isIconVisible;
    $[10] = presetTheme;
    $[11] = subheader;
    $[12] = wrapperClasses;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    t2 = $[13];
    t3 = $[14];
    t4 = $[15];
    t5 = $[16];
    t6 = $[17];
    t7 = $[18];
    t8 = $[19];
    t9 = $[20];
  }
  let t10;
  if ($[34] !== t2 || $[35] !== t3) {
    t10 = <div className={t2}>{t3}</div>;
    $[34] = t2;
    $[35] = t3;
    $[36] = t10;
  } else {
    t10 = $[36];
  }
  let t11;
  if ($[37] !== t10 || $[38] !== t4 || $[39] !== t5) {
    t11 = <div className={t4}>{t5}{t10}</div>;
    $[37] = t10;
    $[38] = t4;
    $[39] = t5;
    $[40] = t11;
  } else {
    t11 = $[40];
  }
  let t12;
  if ($[41] !== t11 || $[42] !== t6) {
    t12 = <div className={t6}>{t11}</div>;
    $[41] = t11;
    $[42] = t6;
    $[43] = t12;
  } else {
    t12 = $[43];
  }
  let t13;
  if ($[44] !== t12 || $[45] !== t7 || $[46] !== t8 || $[47] !== t9) {
    t13 = <div className={t7} style={t8} data-testid={t9}>{t12}</div>;
    $[44] = t12;
    $[45] = t7;
    $[46] = t8;
    $[47] = t9;
    $[48] = t13;
  } else {
    t13 = $[48];
  }
  return t13;
};
function _temp(btn, index) {
  return <TerraLink key={`button-${btn.label}-${index}`} {...btn} />;
}